export default "__VITE_ASSET__3fec591a__"